import React from 'react';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Nav, NavItem } from 'reactstrap';
import { Dropdown, DropdownItem } from 'reactstrap';
import styled from 'styled-components';
import { prop } from 'styled-tools';

import { StyledDropdownMenu, StyledDropdownToggle } from 'components/DropdownNavigation/dropdownNavigation.styles';

import { MediaQuery } from 'components/StyledComponents/MediaQueryRendering';

import { TabsNavigationProps } from 'interfaces/content-stack/modular-blocks/flexibleTabbed';

const StyledNav = styled(Nav)`
  display: flex;
  justify-content: flex-start;
`;

const StyledNavItem = styled(NavItem)`
  font-size: 1.125rem;
  flex: 1;
`;

const StyledNavLink = styled.button`
  cursor: pointer;
  margin-bottom: -1px;
  padding: 0.5rem 1rem;
  width: 100%;
  font-size: 1.125rem;
  font-family: ${(props) => props.theme.fonts.default};
  color: ${(props) => props.theme.colors.mutedGray};

  && {
    background-color: ${prop('theme.colors.white')};
    border: none;
    font-weight: 600;
    text-decoration: none;

    &.active {
      border-radius: 0;
      border-bottom: 0.25rem solid #e21f26;
      color: ${prop('theme.colors.black')};
    }
  }

  &:hover {
    color: ${(props) => props.theme.colors.primaryRed};
    transition: opacity 0.5s;
    transition: color 0.5s;
  }
`;

const TabsNavigation: React.FC<TabsNavigationProps> = ({
  tabs,
  activeTab,
  toggleTab,
  dropdownOpen,
  toggleDropdown,
}) => {
  return (
    <>
      <MediaQuery $mobile>
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <StyledDropdownToggle>
            {tabs[activeTab]?.tabTitle || 'Select Tab'}
            <FontAwesomeIcon size={'xs'} icon={faChevronDown} />
          </StyledDropdownToggle>
          <StyledDropdownMenu>
            {tabs.map((tab, index) => (
              <DropdownItem key={index} onClick={() => toggleTab(index)}>
                {tab.tabTitle}
              </DropdownItem>
            ))}
          </StyledDropdownMenu>
        </Dropdown>
      </MediaQuery>

      <MediaQuery $desktop>
        <StyledNav tabs>
          {tabs.map((tab, index) => (
            <StyledNavItem key={index}>
              <StyledNavLink className={activeTab === index ? 'active' : ''} onClick={() => toggleTab(index)}>
                {tab.tabTitle}
              </StyledNavLink>
            </StyledNavItem>
          ))}
        </StyledNav>
      </MediaQuery>
    </>
  );
};

export default TabsNavigation;
